module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deadline-notice-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Deadline Notice')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [((_vm.notices != null && _vm.notices.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.$t('user_list.label.user_name')))]), _c('th', {
    staticClass: "col-sm-4"
  }, [_vm._v("期限日種類")]), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("期限日")]), (_vm.canReview) ? _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("更新書類")]) : _vm._e()])]), _c('tbody', _vm._l((_vm.notices), function(notice, index) {
    return _c('tr', [_c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goUserPdf(notice.attributes['user-id'])
        }
      }
    }, [_vm._v(_vm._s(notice.attributes['user-name']) + "　" + _vm._s(notice.attributes['user-firstname']) + "　")])]), _c('td', [_vm._v(_vm._s(notice.attributes['target-deadline-i18']))]), _c('td', [(notice.attributes['target-deadline-date-format']) ? _c('span', [_vm._v(_vm._s(notice.attributes['target-deadline-date-format']))]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.$t('deadline_notice.date_unregistered')))])]), (_vm.canReview) ? _c('td', [(_vm.submittedRenewal(notice)) ? _c('a', {
      staticClass: "label label-warning",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.goDocumentRenewal(_vm.submittedRenewal(notice).id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('document_renewal.submitted_badge')))]) : _vm._e()]) : _vm._e()])
  }))])]) : _vm._e(), ((_vm.notices == null || _vm.notices.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59e4aab4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/deadline-notice-list.pug
// module id = 853
// module chunks = 1